//import './navbar.css';
import { Link } from "react-router-dom"
import React, { useEffect, useState } from "react";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Pagination from "react-bootstrap/Pagination";
import Visualizza_singola_ditta from "./Ditta_x9_visualizza_singola_ditta.jsx";


const Impaginazione_bootstrap = (props) => {
  const max_number = 15  
  const [lista_parziale, SET_lista_parziale] = useState([])
  const [numero_pulsanti, SET_numero_pulsanti] = useState(0)

  const [state, setState] = useState({
    data: [],
    limit: 10,
    activePage: 1
  });

  useEffect(() => {

    var new_array_first = []
    if (Array.isArray(props.lista_ditte)) { 
      new_array_first = props.lista_ditte.slice(max_number*(state.activePage-1), max_number*(state.activePage-1) + max_number); 
      SET_numero_pulsanti(Math.ceil( props.lista_ditte.length / max_number ))
    }
    SET_lista_parziale(new_array_first);
  }, [state.limit, state.activePage, props.lista_ditte]);


  useEffect(() => {
    if (props.ricerca_ditta) {
      setState((prev) => ({ ...prev, activePage: 1 }));
    }
  }, [props.ricerca_ditta]);


  const handlePageChange = (pageNumber) => {
    console.log("state.limit: " + state.limit)
  
    console.log("pageNumber: "  + pageNumber)
    setState((prev) => ({ ...prev, activePage: pageNumber }));


  };

  return (
    <div>

        {lista_parziale.map((item) => {
          return (
             <>
              <Visualizza_singola_ditta item= {item} tutor={props.tutor} account_dati={props.account_dati} SET_variab_aggiorna={props.SET_variab_aggiorna}  /> 
              </>
            
          );
        })}
   
      <Pagination className="px-4">
        {Array.from(Array(numero_pulsanti).keys()).map((_, index) => {
          
        
          return (
            <Pagination.Item
              onClick={() => handlePageChange(index + 1)}
              key={index + 1}
              active={index + 1 === state.activePage}
            >
              {index + 1}
            </Pagination.Item>
          );
        })}
      </Pagination>
    </div>
  );
}
export default Impaginazione_bootstrap;

//    const [somma, calcola_somma] = useState('');
